import axios from 'axios';


export const getSemanaDePosgrado = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/SemanaDePosgrado`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("registros recuperados...");
        }
    });

    return result;
}



export const deleteSemanaDePosgrado = async (props) => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/SemanaDePosgrado/${props.id}`;

    let result = [];

    await axios.delete(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("registro eliminado...");
        }
    });

    return result;
}